import { render, staticRenderFns } from "./LegoBoards.vue?vue&type=template&id=77d21bd9&scoped=true"
import script from "./LegoBoards.vue?vue&type=script&lang=js"
export * from "./LegoBoards.vue?vue&type=script&lang=js"
import style0 from "./LegoBoards.vue?vue&type=style&index=0&id=77d21bd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d21bd9",
  null
  
)

export default component.exports